import React from 'react';
import i18next from '../../i18n.js';
import { confirmChangeDialog } from '../ModalDialog.js';

const RouteTypeSwitcher = (props) => {
    const { name, value, disabled } = props;

    const requestChangeHandle = (buttonValue) => {
        if (disabled || buttonValue === (!!value)) return;
        confirmChangeDialog(
            i18next.t('form.fields.routeTypeConfirmTitle'),
            i18next.t('form.fields.routeTypeConfirmText'),
            i18next.t('form.fields.routeTypeConfirmYes'),
            () => {
                if (props.onChange) props.onChange({
                    target: {
                        name,
                        value: !value
                    }
                });
            });
    }

    const renderButton = (buttonValue, label) => (
        <button
            type="button"
            className={"route-type-btn" + ((!!value) === buttonValue ? " selected" : "")}
            onClick={() => requestChangeHandle(buttonValue)}
            disabled={disabled ? "disabled" : ""}>
            {label}
        </button>
    );

    return (<div className="route-type-switcher">
        <div className="route-type-btns">
            {renderButton(false, i18next.t('form.fields.routeTypeSingle'))}
            {renderButton(true, i18next.t('form.fields.routeTypeMulti'))}
        </div>
        <p className="route-type-description">
            {value ? i18next.t('form.fields.routeTypeMultiDescription') : i18next.t('form.fields.routeTypeSingleDescription')}
        </p>
    </div>);
}

export default RouteTypeSwitcher;
